<template>
    <v-dialog :open="show" class="admin-person-info-alert" kind="confirm" @input="handleInput" @confirm="handleConfirm">
        <div slot="title"></div>
        <div class="admin-person-info-alert-content">
            该手机号已关联了
            {{ hasBindTelCount }} 个与本企业资质相同的其他企业，确认将该手机号作为本企业的管理员手机号？
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: {
        hasBindTelCount: {
            type: Number,
            default: 0
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        handleConfirm() {
            this.$emit('on-confirm');
        },
        handleInput(show) {
            this.$emit('update:show', show);
        }
    }
};
</script>

<style lang="less">
.admin-person-info-alert {
    .v-dialog__content {
        padding: 40px 30px;
    }
    &-content {
        width: 380px;
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        color: #1e2330;
    }
}
</style>
